export const formatCurrency = (amount, locale = 'en-US', currency = 'USD') => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencySign: "standard"
    }).format(amount);
};

export const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1); // Months are zero-based
    let day = '' + d.getDate();
    const year = d.getFullYear();
  
    // Add leading zero if month or day is a single digit
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return [month, day, year].join('/');
  };